
const TransportAgentFooter = () => {
	return (
		<div className="w-full border-t-2 px-8 py-2 lg:flex justify-between items-center">
			<p className="lg:mb-0 text-xs">© Copyright 2024</p>
			<div className="flex">
				<a href="#" className="mr-6 hover:text-gray-900 text-xs">Terms of Service</a>
				<a href="#" className="mr-6 hover:text-gray-900 text-xs">Privacy Policy</a>
				<a href="#" className="hover:text-gray-900 text-xs">About Us</a>
			</div>
		</div>
	)
}


export default TransportAgentFooter;